module.exports = __webpack_public_path__ + "img/stick_hiver_ski_rando.340ab2da.svg";